<template>
  <div class="mysearch">
    <header-top :goBackac="true" :mine='true'></header-top>
    <p class="addtext" ref="title">{{$t('my.myFinder')}}</p>
    <div class="pettype">
      <ul>
        <li class="petlist" v-for="(item,index) in petlist" :key="index">
          <div class="petimg">
            <img :src="item.firstPhoto">
          </div>
          <div class="petmsg">
            <p class="petname">{{item.petName}}</p>
            <p class="pettime">{{$t('mysearch.loseTime')}}:{{item.loseTime.slice(0,10)}}</p>
            <p class="pettime">{{$t('mysearch.losePlace')}}:{{item.lostPlace}}</p>
            <p class="findtype" v-if="item.isOpen == '1'">{{$t('mysearch.status')}}:{{$t('mysearch.finding')}}</p>
            <p class="findtype" v-if="item.isOpen == '2'">{{$t('mysearch.status')}}:{{$t('mysearch.finded')}}</p>
            <p class="findtype" v-if="item.isOpen == '0'">{{$t('mysearch.status')}}:{{$t('mysearch.closed')}}</p>
            <el-button
              type="text"
              @click="open(item)"
              style="font-size:0.625rem;padding:5px 0;"
            >{{$t('mysearch.clickToCheck')}}</el-button>
          </div>
          <div class="edit" v-if="item.isOpen == '1'">
            <img src="../../image/edit.png" @click="changefindpetinfo(index)">
          </div>
          <div class="edit" v-if="item.isOpen != '1'">
            <img src="../../image/look.png" @click="searchlist(index)">
          </div>
        </li>
      </ul>
    </div>
    <searchmessage v-if="index" :petlist="index" @show="show"></searchmessage>
    <div class="find" @click="release">
      <span>{{$t('mysearch.publishFind')}}</span>
    </div>
    <!-- <div class="menu-head" ref="item">
      <div class="type">
        <el-dropdown trigger="click" @command="handleCommand">
          <span class="el-dropdown-link" style="color:rgb(89,89,89);font-size:0.8rem;">
            {{$t('mysearch.status')}}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="1">{{$t('mysearch.finding')}}</el-dropdown-item>
            <el-dropdown-item command="2">{{$t('mysearch.finded')}}</el-dropdown-item>
            <el-dropdown-item command="0">{{$t('mysearch.closed')}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="time">
        <span @click="timereverse">
          {{$t('mysearch.time')}}
          <i
            class="el-icon-arrow-down"
            style="padding-left:3px;"
            v-if="!flag4"
          ></i>
          <i class="el-icon-arrow-up" style="padding-left:3px;" v-if="flag4"></i>
        </span>
      </div>
      <div class="find" @click="release" v-show="flag3">
        <img src="../../image/release.png">
        <span>{{$t('mysearch.publishFind')}}</span>
      </div>
    </div> -->
    <!-- <div class="mysearch-main" ref="wrapper">
      <div>
        <div class="pettype">
          <ul v-if="common==1">
            <div v-if="flag==true" class="hint">
              <img src="../../image/addmypet.png" @click="release">
              <p class="rel">{{$t('mysearch.publishFind')}}</p>
            </div>
            <li class="petlist" v-for="(item,index) in petlist" :key="index" v-if="item.isOpen==1">
              <div class="petimg">
                <img :src="item.firstPhoto">
              </div>
              <div class="petmsg">
                <p class="petname">{{item.petName}}</p>
                <p class="pettime">{{$t('mysearch.loseTime')}}:{{item.loseTime.slice(0,10)}}</p>
                <p class="pettime">{{$t('mysearch.losePlace')}}:{{item.lostPlace}}</p>
                <p class="findtype">{{$t('mysearch.status')}}:{{$t('mysearch.finding')}}</p>
                <el-button
                  type="text"
                  @click="open(item)"
                  style="font-size:0.625rem;padding:5px 0;"
                >{{$t('mysearch.clickToCheck')}}</el-button>
              </div>
              <div class="edit">
                <img src="../../image/edit.png" @click="changefindpetinfo(index)">
              </div>
            </li>
          </ul>
          <ul v-if="common==2">
            <p v-if="flag1==true" class="hint">{{$t('mysearch.nofindpet')}}</p>
            <li
              class="petlist"
              v-for="(item,index) in petlist"
              :key="index"
              v-if="item.isOpen==2"
              @click="searchlist(index)"
            >
              <div class="petimg">
                <img :src="item.firstPhoto">
              </div>
              <div class="petmsg">
                <p class="petname">{{item.petName}}</p>
                <p class="pettime">{{$t('mysearch.loseTime')}}:{{item.loseTime.slice(0,10)}}</p>
                <p class="pettime">{{$t('mysearch.losePlace')}}:{{item.lostPlace}}</p>
                <p class="findtype">{{$t('mysearch.status')}}:{{$t('mysearch.finded')}}</p>
              </div>
            </li>
          </ul>
          <ul v-if="common==0">
            <p v-if="flag2==true" class="hint">{{$t('mysearch.nostoppet')}}</p>
            <li
              class="petlist"
              v-for="(item,index) in petlist"
              :key="index"
              v-if="item.isOpen==0"
              @click="searchlist(index)"
            >
              <div class="petimg">
                <img :src="item.firstPhoto">
              </div>
              <div class="petmsg">
                <p class="petname">{{item.petName}}</p>
                <p class="pettime">{{$t('mysearch.loseTime')}}:{{item.loseTime.slice(0,10)}}</p>
                <p class="pettime">{{$t('mysearch.losePlace')}}:{{item.lostPlace}}</p>
                <p class="findtype">{{$t('mysearch.status')}}:{{$t('mysearch.closed')}}</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div> -->
    <!-- <searchmessage v-if="index" :petlist="index" @show="show"></searchmessage>
    <div v-if="isScanrecord" class="scanre">
      <div>
        <p @click="close">X</p>
        <ul>
          <li v-for="scanre in scanrecord">
            {{scanre}}
          </li>
        </ul>
      </div>
    </div> -->
  </div>
</template>
<script>
// import IScroll from "iscroll/build/iscroll-probe";
import headerTop from "../../components/header";
import searchmessage from "../myAccount/searchmessage";
import Qs from "qs";
import { listPublish,getScanner } from "../../ClientServerApi/index.js";
import { getLoginUser } from "../../api/index.js";
import store from "../../store/store.js";
import EXIF from "exif-js/exif.js";
import Axios from 'axios';
import BMap from 'BMap';
// import { listScanner } from "../../ClientServerApi/index.js";
export default {
  name: "mysearch",
  data() {
    return {
      activeName: "first",
      petlist: "",
      time: [],
      fintime: [],
      timelist: [],
      common: 1,
      src1: require("../../image/icon-down.png"),
      flag: true,
      flag1: true,
      flag2: true,
      flag3: false,
      flag4: false,
      flag5: false,
      num: "",
      index: "",
      isScanrecord: false,
      scanrecord:'',
      strScan:''
    };
  },
  components: {
    headerTop,
    searchmessage
  },
  mounted() {
    // this.$refs.wrapper.style.top = this.$refs.title.offsetHeight + this.$refs.item.offsetHeight + 60 + "px";
    // console.log("toubu:",this.$refs.wrapper.style.top)
  },
  created() {
  //   this.$nextTick(() => {
  //     this.Scroll = new IScroll(this.$refs.wrapper, {
  //       click: true,
  //       preventDefault: false
  //     });
  //   });
    listPublish()
      .then(res => {
        this.petlist = res.data.data;
        // console.log("this.listPublish:",res)
        for (var i = 0; i < this.petlist.length; i++) {
          if (this.petlist[i].isOpen == 1 && this.common == 1) {
            this.flag = false;
            this.flag3 = true;
          }
        }
      })
      .catch(error => {
        console.log(error);
      });
      //检验是否登录超时
      if (sessionStorage.getItem("login") == 1) {
        getLoginUser()
          .then(res => {
            if (res.data.header.status == 3019) {
              sessionStorage.setItem("login", "1");
              this.$message({
                type: "success",
                message: this.$t("prompt.header")
              });
              this.$router.push("/login");
            }
          })
          .catch(err => {});
      }
  },
  methods: {
    //时间戳转换成一定格式的时间
    timechange(timelist) {
      timelist.forEach((item, index) => {
        var date = new Date(item); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + "-";
        var M =
          (date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1) + "-";
        var D =
          (date.getDate() < 10 ? "0" + data.getDate() : date.getDate()) + " ";
        var h =
          (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) +
          ":";
        var m =
          (date.getMinutes() < 10
            ? "0" + date.getMinutes()
            : date.getMinutes()) + ":";
        var s =
          date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
        this.fintime.push(Y + M + D +' '+ h + m + s);
      });
    },
    //获取二维码被扫码记录
    open(item) {
      var params = Qs.stringify({
          publishId : item.id
        });
      getScanner(params)
      .then(res=>{
        // console.log("获取次数：",res.data)
        if (res.data.data.length > 0) {
          this.isScanrecord = true;
          if(res.data.header.status==1000){
            var strArr = [];
            var timezone = new Date().getTimezoneOffset()*60000;
            // console.log("时区：",timezone)
            for(let i=0;i<res.data.data.length;i++){
              //时间戳转换成日期
              let timestamp = res.data.data[i].createTime - timezone
              let time = new Date(timestamp)
              let y = time.getFullYear()+"-";
              let month = (time.getMonth() + 1 < 10 ? "0" + (time.getMonth() + 1) : time.getMonth() + 1) + "-";
              let d = (time.getDate() < 10 ? "0" + time.getDate() : time.getDate()) + " ";
              let h = (time.getHours() < 10 ? "0" + time.getHours() : time.getHours()) +":";
              let m = (time.getMinutes() < 10 ? "0" + time.getMinutes() : time.getMinutes()) + ":";
              let s = time.getSeconds() < 10 ? "0" + time.getSeconds() : time.getSeconds();
              // console.log(y,month,d,h,m,s)
              //经纬度转换成地址信息
              let addra = '';
			        let myGeo = new BMap.Geocoder();
              let lng = res.data.data[i].lng;
              let lat = res.data.data[i].lat;
              let pt = new BMap.Point(lng,lat)
              myGeo.getLocation(pt, function(rs){
                // console.log("rs",rs)
                let addComp = rs.addressComponents;
                let addr = addComp.province + addComp.city + addComp.district + addComp.street + addComp.streetNumber;
                addra=addr+' '+y+month+d+h+m+s;
                strArr.push(addra);
              });
            }
            this.scanrecord = strArr;
            // console.log("this.scanrecord",this.scanrecord)
            // this.$alert(this.scanrecord,{
            //   confirmButtonText: this.$t("prompt.sure"),
            //   dangerouslyUseHTMLString: true
            // })
          }
        }
        else {
          this.$alert("<p>" + this.$t("prompt.noscan") + "</p>", {
            confirmButtonText: this.$t("prompt.sure"),
            dangerouslyUseHTMLString: true
          });
        }
      })
      
    },
    close(){
      this.isScanrecord = false;
    },
    handleCommand(command) {
      this.common = command;
      for (var i = 0; i < this.petlist.length; i++) {
        if (this.petlist[i].isOpen == 1 && this.common == 1) {
          this.flag = false;
        }
        if (this.petlist[i].isOpen == 2 && this.common == 2) {
          this.flag1 = false;
        }
        if (this.petlist[i].isOpen == 0 && this.common == 0) {
          this.flag2 = false;
        }
      }
    },
    release() {
      this.$router.push({ path: "/releaseSearch" });
    },
    handleClick(tab, event) {
      //      console.log(tab, event);
    },
    changefindpetinfo(index) {
      this.$router.push({
        name: "changefindpetinfo",
        query: { petinfo: JSON.stringify(this.petlist[index]) }
      });
    },
    timereverse() {
      this.petlist.reverse();
      if (this.num == 1) {
        this.flag4 = false;
        this.num = "";
      } else {
        this.flag4 = true;
        this.num = 1;
      }
    },
    searchlist(index) {
      this.index = this.petlist[index];
      // if(this.index){
      // this.$refs.banner.show()
      // }
    },
    show() {
      this.index = "";
    }
  }
};
</script>
<style>
.mysearch-main .el-tabs__nav {
  width: 100%;
  display: flex;
}
.mysearch-main .el-tabs__active-bar {
  height: 1px;
  width: 40px;
}
.mysearch-main #tab-first {
  flex: 1;
  text-align: center;
}
.mysearch-main #tab-second {
  flex: 1;
  text-align: center;
}
.mysearch-main #tab-third {
  flex: 1;
  text-align: center;
}
.el-dropdown-menu__item {
  width: 100px;
}
.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: rgb(238, 238, 238);
  color: rgb(107, 107, 107);
}
</style>
<style scoped>

.addtext {
  text-align: center;
  font-size: 1rem;
  color: #333333;
  padding: 20px 0;
}
.hint {
  margin-top: 20px;
  text-align: center;
  font-size: 0.875rem;
}
.hint img {
  margin-top: 20%;
  width: 6.25rem;
  height: 6.25rem;
}
.rel {
  font-size: 1rem;
  color: rgb(89, 89, 89);
}
.menu-head {
  margin-top: 20px;
  margin-bottom: 5px;
  display: flex;
}
.type {
  flex: 4;
  text-align: center;
  margin-left: 15px;
}
.time {
  flex: 4;
  font-size: 0.8rem;
  color: rgb(89, 89, 89);
  margin-top: 2px;
  text-align: center;
}
.find {
  width: 72%;
  margin-left: 14%;
  font-size: 1rem;
  height: 2.6rem;
  line-height: 2.6rem;
  color: rgb(255,255,255);
  margin-top: 30px;
  border-radius: 1.3rem;
  background-image: linear-gradient(to right , #65d3e8, #7dc3f2);
  border: 0;
  text-align: center;
  color: #ffffff;
  margin-bottom: 30px;
}

.mysearch-main {
  width: 100%;
  position: absolute;
  top: 140px !important;
  overflow: hidden;
  touch-action: none;
}
.petlist {
  position: relative;
  display: flex;
  border-bottom: solid 1px #dcdcdc;
}
.petimg img {
  width: 120px;
  height: 85px;
  padding: 15px 10px;
  object-fit: cover;
}
.petmsg {
  flex: 1;
  padding: 15px 0;
}
.petname {
  font-size: 0.875rem;
  font-weight: 600;
  color: rgb(57, 57, 57);
}
@media screen and (min-width: 320px) and (max-width: 568px) {
  .pettime {
    padding-top: 5px;
    font-size: 0.8rem;
    width: 170px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
@media screen and (min-width: 375px) and (max-width: 667px) {
  .pettime {
    padding-top: 5px;
    font-size: 0.75rem;
    width: 140px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
@media screen and (min-width: 414px) {
  .pettime {
    padding-top: 5px;
    font-size: 0.75rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.findtype {
  padding-top: 5px;
  font-size: 0.625rem;
}
.edit {
  width: 50px;
  position: relative;
  right: 20px;
}
.edit img {
  position: absolute;
  top: 15px;
  width: 20px;
  /* height: 20px; */
}
.pettype ul {
  overflow: scroll;
  border-top: 1px solid #dcdcdc;
}
.scanre{
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.6);
  margin: 0 auto;
  z-index: 999;
  top: 0;
  display: flex;
	align-items: center;
}
.scanre div{
  width: 95%;
  margin: 0 auto;
  height: auto;
  max-height: 350px;
  background: #ffffff;
	border-radius: 5px;
	box-sizing: border-box;
  padding: 40px 0;
  position: relative;
}
.scanre div p{
  width: 25px;
  height: 25px;
	border-radius: 50%;
  border: 4px solid #eeeeee;
  position: absolute;
  top: 5px;
  right: 5px;
  text-align: center;
  line-height: 25px;
  color: #666;
}
.scanre ul{
  width: 100%;
  height:auto;
  max-height: 270px;
  overflow: auto;
  /* overflow-y:scroll; */
  /* -webkit-overflow-scrolling:touch; */
  margin-top: 5px;
}
.scanre ul li{
  width: 90%;
  margin-left: 5%;
  justify-content: center;
  line-height: 1.6rem;
  font-size: 0.8rem;
  border: 0px;
  border-bottom: 1px solid #666;
	border-style: dashed;
  color: #333;
  flex-direction:column-reverse;
}
</style>



// WEBPACK FOOTER //
// src/m_page/myAccount/mysearch.vue